import { fetchSortitionParams } from '../../../../api/sortition.api.js';
import Validatable from '../../../mixins/Validatable.js';
import ContentLoader from '../../../mixins/ContentLoader.js';
import SortitionForm from '../../../components/sortition/SortitionForm.vue';
import { ValidationObserver } from 'vee-validate';

export default {
	components: {
		SortitionForm,
		ValidationObserver
	},
	mixins: [Validatable, ContentLoader],
	data() {
		return {
			sortition: {
				name: '',
				resultFields: [],
				schedules: [],
				pickTwoEquivalentSortition: '',
				equivalentSortition: '',
				isPeriodic: false,
				periodicSortitionNumber: null
			},
			params: {
				resultFields: [],
				weekdays: []
			}
		};
	},
	methods: {
		async fetchParams() {
			try {
				const response = await fetchSortitionParams(),
					{ weekdays, resultFields } = response.data;

				this.params.weekdays = weekdays;
				this.params.resultFields = resultFields;
			} catch (e) {
				console.error(e);
			}
		}
	}
};
